import React from "react";

function calculateString(list, sep = "") {
  let str = "";
  if (list && list.length > 0) {
    list.map(({name}, idx) => {
      str = str + name;
      if (idx < list.length - 1) {
        str += sep + " "
      }
    })
  }
  return str;
}

function nameListExcelCell(options, column, gridCell) {
  let row = gridCell.data;
  let prefix = column.dataField;
  options.value = calculateString(row[prefix], ";");
}

function nameListCell(config, columnSpec) {
  let field = columnSpec.dataField;
  config.cellRender = NameListCell;
  config.dataType = "string";
  config.calculateCellValue = (row) => {
    if (row[field]) {
      return calculateString(row[field]);
    } else {
      return null;
    }
  }
}

const NameListCell = (cellData) => {
  let list = cellData.data[cellData.column.dataField];
  return (<div>{list && list.length > 0 && list.map(({name}) => <div key={name}>{name}</div>)}</div>);
};

export {nameListCell, nameListExcelCell}
